import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ProfileCard.css';

const ProfileCard = React.memo(({ isVIP, username, vipInfo }) => {
    const navigate = useNavigate();
    
    const isGoldCard = isVIP;
    const cardClass = isGoldCard ? 'vip-active' : 'vip-regular';
    
    // Determine expiry text
    let expiryText = 'Active';
    let expiryLabel = 'Status';
    
    if (isGoldCard) {
        const isPermanent = vipInfo?.vip_status === 'vip_permanent' || vipInfo?.vip_status === 'permanent';
        
        if (isPermanent) {
            expiryText = 'Selamanya';
            expiryLabel = 'Status';
        } else if (vipInfo?.vip_expires_at) {
            const expiryDate = new Date(vipInfo.vip_expires_at);
            expiryText = expiryDate.toLocaleDateString('id-ID', {
                day: '2-digit', 
                month: 'short', 
                year: 'numeric'
            });
            expiryLabel = 'Valid Until';
        }
    }

    return (
        <div className="profile-card-section">
            <div className={`vip-card ${cardClass}`}>
                <div className="vip-card-content">
                    {/* Logo Section */}
                    <div className="vip-logo-section">
                        <div className="vip-logo-container">
                            <div className="vip-logo">
                                <i className="fas fa-play-circle"></i> DinoShort
                            </div>
                            {isGoldCard && (
                                <div className="vip-benefit-text">VIP Benefit</div>
                            )}
                        </div>
                        {isGoldCard ? (
                            <div className="vip-type-badge vip-gold"></div>
                        ) : (
                            <div className="vip-type-badge regular-silver">REGULAR</div>
                        )}
                    </div>

                    {/* Username Section */}
                    <div className="vip-username-section">
                        <h3 className="vip-username">{username}</h3>
                        <div className="vip-membership-text">
                            {isGoldCard ? 'Premium Membership' : 'Standard Membership'}
                        </div>
                    </div>

                    {/* Bottom Section */}
                    <div className="vip-bottom-section">
                        <div className="vip-expiry-info">
                            <span className="vip-expiry-label">{expiryLabel}</span>
                            {expiryText}
                        </div>
                        <div className="vip-chip"></div>
                    </div>
                </div>
            </div>

            {/* Action Buttons */}
            <div className="vip-actions">
                {isGoldCard ? (
                    <button 
                        className="vip-btn-profile"
                        onClick={() => navigate('/vip')}
                    >
                        <i className="fas fa-crown"></i>
                        {vipInfo?.vip_status === 'vip_permanent' ? 'VIP Selamanya' : 'Perpanjang VIP'}
                    </button>
                ) : (
                    <button 
                        className="upgrade-btn"
                        onClick={() => navigate('/vip')}
                    >
                        <i className="fas fa-crown"></i> Upgrade ke VIP
                    </button>
                )}
            </div>
        </div>
    );
});

ProfileCard.displayName = 'ProfileCard';

export default ProfileCard;

